import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@yonderland/andes-icons';
import { IconButton, ListBox, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
const NewLanguagePopover = ({ currentLang, alternateUrl }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isCurrentLang = (language) => language === currentLang;
    const getLabel = (language) => `${t(`language.${language}`)} (${language.toUpperCase()})`;
    return (_jsx(ListBox, { children: _jsx(ListBox.Group, { children: Object.keys(alternateUrl)
                .sort((a, b) => Number(isCurrentLang(b)) - Number(isCurrentLang(a)))
                .map((lang, index) => {
                const isSelected = isCurrentLang(lang);
                return (_jsx(ListBox.Item, { paddingBlock: "3", paddingInline: isSelected ? '1' : '3', testId: `${index}-${lang}`, state: isSelected ? 'selected' : 'enabled', href: alternateUrl[lang], children: _jsxs(Stack, { align: "center", children: [isSelected && (_jsx(IconButton, { variant: "plain", icon: { source: CheckIcon, size: 'sm', color: 'emphasised' }, size: "sm" })), _jsx(TextAlpha, { strong: isSelected, variant: "bodyM", color: isSelected ? 'emphasised' : 'neutral', children: getLabel(lang) })] }) }, lang));
            }) }) }));
};
export default NewLanguagePopover;
